import { useMemo } from "react";
import { useSelector } from "react-redux";
import jobSelectors from "store/selectors/job";
import { selectors } from "store";

export interface JobFinanceStatusPropsHook {
  financeStatus?: string;
  timestamp?: Date;
  status?: string;
  price?: number;
  isLoading?: boolean;
}

export default function useJobFinanceStatusProps(): JobFinanceStatusPropsHook {
  const isLoading = useSelector(selectors.getIsLoading);
  const job = useSelector(jobSelectors.getEntity);
  const checkJob = useSelector(selectors.checkJob.getEntity);

  const financeStatus = useMemo(() => {
    if (!job || !checkJob) return "not_applied";
    if (job?.finance_status === "financed") {
      const payment = [...(job?.payments || [])]
        ?.sort((p1, p2) => {
          const p1Date = p1?.metadata?.created_at as unknown as number;
          const p2Date = p2?.metadata?.created_at as unknown as number;

          return (
            (new Date(p2Date) as unknown as number) -
            (new Date(p1Date) as unknown as number)
          );
        })
        ?.filter((p) => p?.payment_option?.payment_method === "card")?.[0];
      if (!payment) return job?.finance_status;
      if (
        checkJob?.current_status &&
        ["accepted_sign_document", "accepted_deposit_required"]?.includes(
          checkJob.current_status
        )
      )
        return "applied_for_finance";
      return job?.finance_status;
    }
    return job?.finance_status;
  }, [job, checkJob]);

  return {
    financeStatus,
    timestamp: job?.metadata?.updated_at,
    status: job?.status || "draft",
    price: job?.total?.amount_vat_inclusive?.amount || 0,
    isLoading,
  };
}
